import React from "react";
import styles from "./ContactUs.module.css";

const pageData = {
    sections: [
        {
            type: "hero",
            headline: "Get in Touch with Toxbox AI",
            content:
                "Have questions about our enterprise AI platform, AI-powered chatbots, or intelligent virtual assistants? Reach out to our team for inquiries, demos, or partnership opportunities.",
            cta: "Request a Demo",
        },
        {
            type: "form",
            headline: "Send Us a Message",
            content:
                "Fill out our web form for quick responses. Our experts in conversational AI and workflow automation will get back to you promptly.",
            form: {
                fields: [
                    { label: "Name", type: "text", placeholder: "Enter your name" },
                    { label: "Email", type: "email", placeholder: "Enter your email" },
                    { label: "Company", type: "text", placeholder: "Enter your company" },
                    { label: "Role", type: "text", placeholder: "Your role in company" },
                    { label: "Message", type: "textarea", placeholder: "Write your message" },
                ],
                cta: "Submit",
            },
        },
        {
            type: "contact",
            headline: "Direct Contact Options",
            content: "Prefer direct contact? Reach our team at:",
            items: [
                { type: "email", value: "info@toxbox.ai" },
                { type: "phone", value: "+1-800-TOXBOX" },
            ],
        },
        {
            type: "text",
            headline: "Our Global Presence",
            content:
                "Connect with Toxbox AI offices worldwide for enterprise inquiries and demos. Highlight regional expertise in AI solutions for fintech, healthcare, e-commerce, and education.",
        },
        {
            type: "cta",
            headline: "See Toxbox AI in Action",
            content:
                "Schedule a personalized demo to explore automated customer support AI, digital transformation solutions, and workflow automation with AI.",
            ctab: "Book Your Demo",
        },
        {
            type: "faq",
            headline: "Frequently Asked Questions",
            content:
                "Answers to common inquiries about Toxbox AI platforms, conversational AI integration, and enterprise AI solutions.",
            items: [
                "How does Toxbox AI integrate with existing platforms?",
                "What industries benefit most from Toxbox AI?",
                "Can Toxbox AI handle multi-language support?",
            ],
        },
        {
            type: "newsletter",
            headline: "Stay Updated with Toxbox AI",
            content:
                "Subscribe to our newsletter to receive the latest AI news, product updates, and enterprise conversational AI insights.",
            ctaa: "Subscribe Now",
        },

    ],

};

const Contact = () => {
    return (
        <div className={styles.contactPage}>
            {pageData.sections.map((section, index) => {
                switch (section.type) {
                    case "hero":
                        return (
                            <section key={index} className={styles.hero}>
                                <h1 className={styles.headline}>{section.headline}</h1>
                                <p className={styles.content}>{section.content}</p>
                                {section.cta && (
                                    <a href="#demo" className={styles.cta}>
                                        {section.cta}
                                    </a>
                                )}
                            </section>
                        );

                    case "form":
                        return (
                            <section key={index} className={styles.section}>
                                <h2 className={styles.sectionTitle}>{section.headline}</h2>
                                <p className={styles.content}>{section.content}</p>
                                <form className={styles.form}>
                                    {section.form.fields.map((field, idx) =>
                                        field.type === "textarea" ? (
                                            <textarea
                                                key={idx}
                                                placeholder={field.placeholder}
                                                required
                                                className={styles.input}
                                            ></textarea>
                                        ) : (
                                            <input
                                                key={idx}
                                                type={field.type}
                                                placeholder={field.placeholder}
                                                required
                                                className={styles.input}
                                            />
                                        )
                                    )}
                                    <button type="submit" className={styles.cta}>
                                        {section.form.cta}
                                    </button>
                                </form>
                            </section>
                        );

                    case "contact":
                    case "faq":
                        return (
                            <section key={index} className={styles.cardsSection}>
                                <h2 className={styles.sectionTitle}>{section.headline}</h2>
                                <p className={styles.content}>{section.content}</p>
                                <div className={styles.cardsContainer}>
                                    {section.items?.map((item, idx) => (
                                        <div key={idx} className={styles.card}>
                                            <p>{item.value || item}</p>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        );

                    case "cta":
                        return (
                            <section key={index} className={styles.ctaSection}>
                                <h2 className={styles.sectionTitle}>{section.headline}</h2>
                                <p className={styles.content}>{section.content}</p>
                                <a href="#book-demo" className={styles.ctab}>
                                    {section.ctab}
                                </a>
                            </section>
                        );

                    case "newsletter":
                        return (
                            <section key={index} className={styles.newsletter}>
                                <h2 className={styles.sectionTitle}>{section.headline}</h2>
                                <p className={styles.content}>{section.content}</p>
                                <form className={styles.formInline}>
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        required
                                        className={styles.input}
                                    />
                                    <button type="submit" className={styles.ctaa}>
                                        {section.ctaa}
                                    </button>
                                </form>
                            </section>
                        );

                    default:
                        return (
                            <section key={index} className={styles.section}>
                                <h2 className={styles.sectionTitle}>{section.headline}</h2>
                                <p className={styles.content}>{section.content}</p>
                            </section>
                        );
                }
            })}
            {/* <FooterComponent /> */}
        </div>
    );
};

export default Contact;
